import { SectionMessage, Stack } from "@certn/cascadia-react";
import { SearchableSelectControl } from "@certn/forms/src/controls/SearchableSelectControl";
import { CascadiaJsonFormContext } from "@certn/forms/src/CascadiaJsonFormContext";
import { CascadiaControlProps } from "@certn/forms/src/wrappers/withCascadiaControlProps";
import { useContext } from "react";

import { QualifyingEmployer } from "./types";
import { getDocumentTypeOption } from "./utils";

export function EmploymentDocumentTypeControl(props: CascadiaControlProps) {
  const { values } = useContext(CascadiaJsonFormContext);
  const employers: QualifyingEmployer[] =
    props.uischema?.options?.qualifying_employers ?? [];
  const employer = employers.find(
    (employer) => employer.employer_id === values?.employer_id
  );
  const documentTypes = employer?.document_types ?? [];
  const items = documentTypes.map((option) => ({
    label: option.title,
    value: option.const,
  }));
  const selectedDocumentType = getDocumentTypeOption(
    documentTypes,
    typeof props.data === "string" ? props.data : undefined
  );

  return (
    <Stack gap="space-3">
      <SearchableSelectControl
        {...props}
        label={props.uischema.label as string}
        items={items}
        required
        enabled={items.length > 0}
      />
      {selectedDocumentType?.hint && (
        <SectionMessage
          type={selectedDocumentType.hint_level ?? "info"}
          icon={selectedDocumentType.hint_level ?? "info"}
          testID="employment-document-type-hint"
        >
          {selectedDocumentType.hint}
        </SectionMessage>
      )}
    </Stack>
  );
}
